//import { HTTP } from '@ionic-native/http/ngx';

import React, { useState, useContext, useEffect } from 'react';
import { Route, Redirect, Switch, useHistory } from 'react-router-dom';


import { Auth_Zasava_Context } from '../storeState/Auth_Zasava_Context'

import { Preferences } from '@capacitor/preferences';
import { NativeBiometric } from "capacitor-native-biometric";
import { BiometryType } from "capacitor-native-biometric";
import { useIonRouter } from '@ionic/react';

import Cookie from 'universal-cookie';



let cookies = new Cookie();


async function setAppDevice(event) {

    //alert('inside setAppDevice');
    //alert(event[0]);
    //alert(event[1]);
    //alert(event[2]);
    //alert(event[3]);

    Preferences.set({
        key: 'isBiometricFingerprintAvilable',
        value: event[0],
    })
    Preferences.set({
        key: 'device',
        value: event[1],
    })
    // Preferences.set({
    //     key: 'baseURL',
    //     value: event[2],
    // })
    
}

async function setAppDevice_fingerprint(event) {

    //alert('inside setAppDevice');
    //alert(event[0]);
    //alert(event[1]);
    //alert(event[2]);
    //alert(event[3]);

    Preferences.set({
        key: 'biometricFingerprint',
        value: event,
    })
    
}

async function setAppDevice_authenticated(event) {

    //alert('inside setAppDevice');
    //alert(event[0]);
    //alert(event[1]);
    //alert(event[2]);
    //alert(event[3]);

    Preferences.set({
        key: 'isAuthenticated',
        value: event,
    })
    
}

async function setWebsocket_wss(event) {

    Preferences.set({
        key: 'websocket',
        value: event,
    })
    
}


async function removeStorageCredentials() {


    await Preferences.remove({ key: 'accountID' });
    await Preferences.remove({ key: 'employeeID' });
    await Preferences.remove({ key: 'employee_first_name' });
    await Preferences.remove({ key: 'employee_last_name' });
    await Preferences.remove({ key: 'employee_company' });
    await Preferences.remove({ key: 'employee_createdBy' });
    await Preferences.remove({ key: 'schemaName' });
    await Preferences.remove({ key: 'isAuthenticated' });
    await Preferences.remove({ key: 'accessRights' });
    await Preferences.remove({ key: 'loginUsername_authenticated' });
    await Preferences.remove({ key: 'loginPassword_authenticated' });
    await Preferences.remove({ key: 'isBiometricFingerprintAvilable' });
    await Preferences.remove({ key: 'biometricFingerprint' });
    await Preferences.remove({ key: 'device' });
    await Preferences.remove({ key: 'sessionID' });
    await Preferences.remove({ key: 'baseURL' });
    await Preferences.remove({ key: 'capability' });
    await Preferences.remove({ key: 'feature' });
    await Preferences.remove({ key: 'fcm_token' });
    await Preferences.remove({ key: 'latitude_current' });
    await Preferences.remove({ key: 'longitude_current' });
    await Preferences.remove({ key: 'chatID_list' });
    await Preferences.remove({ key: 'websocket' });

    let remove_cookie = null;

    cookies.remove('session', remove_cookie);


}

function setStorageCredentials_sessionID(event) {

    //alert('In setStorageCredentials_sessionID');
    //alert(event);

    Preferences.set({
        key: 'sessionID',
        value: event,
    })
}

function setStorageCredentials_accessRights(event) {

    Preferences.set({
        key: 'accessRights',
        value: [event[0], event[1], event[2], event[3],  event[4]].toString(),
    })

}


export function PrivateRoute_Zasava ({ children, ...rest }) {
//export class PrivateRoute extends React.Component {
//const PrivateRoute: React.FC = () => {


    let authZasava_context = useContext(Auth_Zasava_Context);

    //alert('In PrivateRoute');
    //alert(authMerchant_objects.acctID);

    let [validation, setValidation ] = useState(null);
    let [acctID, setAccountID ] = useState(authZasava_context.acctID);
    let [schema, setSchema ] = useState(authZasava_context.schema);
    //let [cookieID, setCookie ] = useState(false);
    let [sessionID, setSessionID ] = useState(authZasava_context.sessionID);

    let [isBiometric_fingerprintAvilable, setIsBiometric_fingerprintAvilable ] = useState(authZasava_context.isBiometric_fingerprintAvailable);
    let [biometric_fingerprint, setBiometric_fingerprint] = useState(authZasava_context.biometric_fingerprint);
    let [device, setDevice ] = useState(authZasava_context.device);
    let [baseURL, setBaseURL ] = useState(authZasava_context.baseURL);
    let [wss, setWebsocket ] = useState(authZasava_context.websocket);

    let [merchantLoginModal, setMerchantLoginModal] = useState(false);


    let history = useHistory();

    const router = useIonRouter();


      useEffect(() => {

        //alert('In Private Route UseEffect');

        NativeBiometric.isAvailable().then(
            (result) => {
                
            const isAvailable = result.isAvailable;
            const isAvailable_isFingerPrint = result.biometryType == BiometryType.FINGERPRINT;
            //const isFaceId = result.biometryType == BiometryType.FACE_ID;

                // alert(isAvailable);
                // alert(isAvailable_isFingerPrint);


                let baseURL = "";

                if(isAvailable == true && isAvailable_isFingerPrint == false) 
                {
                    //alert("is Fingerprint = false")
                    
                    setAppDevice(['no', 'mobile']);
                    setAppDevice_fingerprint('no');

                    //baseURL = 'https://zasavatesttest.com/';
                    //authZasava_context.changeBaseURL('https://zasavatesttest.com/');


                }

                else if(isAvailable == true && isAvailable_isFingerPrint == true) 
                {
                    //alert("is Fingerprint = true")
                    
                    setAppDevice(['yes', 'mobile']);

                    //baseURL = 'https://zasavatesttest.com/';

                }
                else if (isAvailable == false && isAvailable_isFingerPrint == false) 
                {
                    //alert("is available = false")

                    setAppDevice(['no', 'desktop']);
                    setAppDevice_fingerprint('no');

                    //baseURL = window.location;
                    //authZasava_context.changeBaseURL(window.location);

                }


                const requestOptions = {
                    method: 'POST',
                    //credentials: 'include',
                    headers: {
                        'Accept': 'text/html, application/json',
                        'content-type': 'application/json',
                        cookie: cookies.get('session'),
                    },
                    body: JSON.stringify({
                        Tracker: 'session_check',
                        user: authZasava_context.acctID,
                        sessionID: authZasava_context.sessionID,
                    }),
                }

                //alert(baseURL);

                fetch(baseURL+'zsava_public_indexApp', requestOptions)
                //Http.request(baseURL+'zsava_public_indexApp', requestOptions)
                //fetch('http://localhost/', requestOptions)
                .then(res => res.json())
                .then(res => {

                    //alert('PRIVATE ROUTE -  YES FINGERPRINT - CHECKED SESSION');
                    // alert(res);
                    //alert(res.toString());
                    // alert(authZasava_context.biometric_fingerprint);


                    if (isAvailable_isFingerPrint == true && authZasava_context.biometric_fingerprint == 'yes' && res.toString() == '1') 
                    {
                        //alert("is Fingerprint = true / authenticated and Session is Authenticated")
                        // alert(authZasava_context.authenticated);
                        // alert(authZasava_context.loginUsername);
                        // alert(authZasava_context.loginPassword);

                        history.push(window.location);
    
                    }

                    else if (isAvailable_isFingerPrint == true && authZasava_context.biometric_fingerprint == 'no' && res.toString() == '1') 
                    {
                        alert("INACTIVE SESSION, PLEASE LOG BACK IN");
                        removeStorageCredentials();
    
                    }
                    else if (isAvailable_isFingerPrint == true && authZasava_context.biometric_fingerprint == 'yes' && res.toString() == '0') 
                    {
                        //alert("is Fingerprint = true  but NOT AUTHENTICATED")

                        //setMerchantLoginModal(true);


                        authZasava_context.changeAuthenticated(null);
                        setAppDevice_authenticated(null);

                        //history.push('/login');
    
                        //setMerchantLoginModal(true)        
                    }
                })

            },
            (error) => {

               // alert('PRIVATE ROUTE - NO BIOMETRICS');
                // alert(cookies.get('session'));
                // alert(cookies.get('session').cookie.originalMaxAge);
                // alert(cookies.get('session').user);
                // alert(cookies.get('session').schema);
                // alert(cookies.get('session').createdBy);


                const requestOptions = {
                    method: 'POST',
                    //credentials: 'include',
                    headers: {
                        'Accept': 'text/html, application/json',
                        'content-type': 'application/json',
                        cookie: cookies.get('session'),
                    },
                    body: JSON.stringify({
                        Tracker: 'session_check',
                        user: authZasava_context.acctID,
                        sessionID: authZasava_context.sessionID,
                    }),
                }

                fetch(baseURL+'zsava_public_indexApp', requestOptions)
                //Http.request(baseURL+'zsava_public_indexApp', requestOptions)
                //fetch('http://localhost/', requestOptions)
                .then(res => res.json())
                .then(res => {

                    //alert('PRIVATE ROUTE - NO BIOMETRICS - CHECKED SESSION');
                    //alert(res.toString());
                    // alert(authZasava_context.authenticated);
                    //alert(res.toString());
                    // alert(authZasava_context.biometric_fingerprint);
                    if(res.toString() == '0')
                    {

                        //alert('NO BIOMETRICS - NO SESSION');

                        removeStorageCredentials();

                        window.location.reload(); // Refresh the page on session expiration

                        //reloadPage();
                    }

                    if(res.toString() == '1')
                    {

                        //alert('NO BIOMETRICS - ACTVIE SESSION');

                        history.push(window.location);
                    }


                })


                //authZasava_context.changeBiometric_fingerprint(false);
                //authZasava_context.changeDevice(false);
                //authZasava_context.changeDevice('desktop');
            }
        );
      }, [])  



      useEffect(() => {

        //alert("In Websocket Use Event");

        if(wss == null && window.location.origin.includes('test'))
        {
            wss = new WebSocket('wss://zasavatest.com/ws/');
            //setWebsocket_wss(wss);
            //setWebsocket(wss);
            authZasava_context.changeWebsocket(wss);
        }
        else if (wss == null)
        {
            wss = new WebSocket('wss://zasava.com/ws/');
            //setWebsocket_wss(wss);
            //setWebsocket(wss);
            authZasava_context.changeWebsocket(wss);
        }
        
        wss.onopen = () => {
            alert('WebSocket connection established');

            //alert('WebSocket connection established');
          };
    
        wss.onmessage = (event) => {

          const data = JSON.parse(event.data);

          if (data.type === 'UPDATE_SESSION')
          {

            //alert(`Session ACTIVE - UPDATING: ${event}`);
            // alert(`Session ACTIVE - UPDATING: ${data.new_cookie}`);
            // alert(`Session ACTIVE - UPDATING: ${JSON.parse(event.data)}`);
            // alert(`Session ACTIVE - UPDATING: ${data}`);

            cookies.set('session', data.new_cookie);

          }

          if (data.type === 'REMOVE_SESSION')
          {
            //alert('WebSocket connection Removing Session');

            // alert(`Session ACTIVE - UPDATING: ${event}`);
            // alert(`Session ACTIVE - UPDATING: ${data.new_cookie}`);
            // alert(`Session ACTIVE - UPDATING: ${JSON.parse(event.data)}`);
            // alert(`Session ACTIVE - UPDATING: ${data}`);
            removeStorageCredentials();

          }


          if (data.type === 'SESSION_EXPIRED') 
          {

            if(authZasava_context.device == 'mobile' && data.sessionId == authZasava_context.sessionID)
            {

                //alert(`Session expired: ${data.sessionId}`);


                NativeBiometric.verifyIdentity({
                    reason: "VERIFY",
                    title: "Biometric Setup",
                    subtitle: "Authenticate to continue",
                    description: "Place your finger on the sensor",
                }).then(() => {


                        const requestOptions = {
                            method: 'POST',
                            //credentials: 'include',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                            },
                            //body: formData
                            body: JSON.stringify({
                                    Tracker: '9000',
                                    xUsername: authZasava_context.loginUsername,
                                    xPassword: authZasava_context.loginPassword,
                                })
                        }

                        fetch(baseURL+'zsava_public_indexApp', requestOptions)
                        //Http.request(baseURL+'zsava_public_indexApp', requestOptions)
                        //fetch('http://localhost/', requestOptions)
                        .then(res => res.json())
                        .then(res => {
                            

                            let rows = res.out.toString().split('~~~');
                            let lines = rows[0].split('|');
                            let lines2 = rows[1].split('|');


                            if (lines[0] === "2" || lines[0] === "3" || lines[0] === "4" || lines[0] === "5")
                            {

                                // alert("In authenticating");
                                // alert(lines[7]);

                                setStorageCredentials_sessionID(res.id.toString());
                                setAppDevice_authenticated(lines[7]);
                                authZasava_context.changeSessionID(res.id.toString());
                                authZasava_context.changeBiometric_fingerprint(true);
                                authZasava_context.authenticated(lines[7]);

                            }
                            else
                            {
                                alert("Fingerprint RETRIEVAL Authentication Failed");
                            }
                        })

                        alert("Fingerprint Authentication Successful");


                })
                .catch((error) => {
                    //alert(error);
                    //alert("WebSocket Fingerprint Authentication Failed");
                    //removeStorageCredentials();
                    window.location.reload(); // Refresh the page on session expiration

                });
                
            }
            else if(authZasava_context.device == 'desktop')
            {
                //alert('WebSocket connection Removing Session');

                removeStorageCredentials();
                window.location.reload(); // Refresh the page on session expiration
            }
          }
        };

        wss.onerror = (error) => {
            //alert('WebSocket error: '+ JSON.stringify(error));
            
            //alert('WebSocket readyState: ' + wss.readyState);


           //window.location.reload(); // Refresh the page on session expiration


          };
          
          wss.onclose = () => {
            //alert('WebSocket connection closed');


            //window.location.reload(); // Refresh the page on session expiration



          };
    
        return () => wss.close(); // Cleanup WebSocket connection

      }, []);




    //alert('In PrivateRoute');
    //alert(authZasava_context.authenticated);
    //alert(authMerchant_objects.isBiometric_fingerprintAvailable);
    //alert(biometric_fingerprint);

    return (
        <Route
          {...rest}
          render={({ location }) =>
          authZasava_context.authenticated != null ? (
              <React.Fragment>
                {children}
            </React.Fragment>
            ) : (
              <Redirect
                to={{
                  pathname: '/login', // Redirect to login page or any unauthorized route
                  state: { from: location },
                }}
              />
            )
          }
        />
      );
    

};

